module.exports = __webpack_public_path__ + "img/app-button-mb.2f1bf99f.svg";